<app-nav></app-nav>
<div class="md:ms-56 px-4 py-12">
  <router-outlet></router-outlet>
</div>